export interface ProductInfoLabelParams {
  productName: string
  expirationDate: string
  entryDate: string
  quantity: string
  upc: string
  batch: string
}

const convertDateToYYMMDD = (dateStr: string): string => {
  const [day, month, year] = dateStr.split('/')
  const yy = year.slice(-2)
  return `${yy}${month}${day}`
}

export const getProductInfoLabelToPrint = (
  params: Partial<ProductInfoLabelParams> = {}
) => {
  const defaultParams = {
    productName: 'Champiñones Rebanados Justo 250g',
    expirationDate: '22/07/2025',
    entryDate: '',
    quantity: 45,
    upc: '7503039045705',
    batch: '130725'
  }

  const finalParams = { ...defaultParams, ...params }
  const qrExpDate = convertDateToYYMMDD(finalParams.expirationDate)
  const labelVersion = 'A'

  return `
^XA
^CI28
^FWN

^FO160,60
^BQN,2,10
^FDLA,(01)0${finalParams.upc}(10)${finalParams.batch}(17)${qrExpDate}(91)${labelVersion}^FS

^CF0,50
^FO30,430^FDNombre:^FS
^CF0,40
^FO30,500^FB550,3,0,L,0^FD${finalParams.productName}^FS

^CF0,40
^FO30,670^FDCaducidad:^FS
^FO30,720^FD${finalParams.expirationDate}^FS

^CF0,40
^FO320,670^FDIngreso:^FS
^FO320,720^FD${finalParams.entryDate}^FS

^CF0,40
^FO30,830^FDCantidad:^FS
^FO30,880^FD${finalParams.quantity}^FS

^CF0,40
^FO320,830^FDLote:^FS
^FO320,880^FD${finalParams.batch}^FS

^BY3,2.0
^FO38,1000
^BCN,130,Y,N,N
^FD${finalParams.upc}^FS

^FO10,10^GB590,1200,5^FS

^XZ`
}
